'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FETCH_DATA = exports.FETCH_DATA = 'FETCH_DATA';
var FETCH_DATA_IN_PROGRESS = exports.FETCH_DATA_IN_PROGRESS = 'FETCH_DATA_IN_PROGRESS';
var FETCH_DATA_COMPLETE = exports.FETCH_DATA_COMPLETE = 'FETCH_DATA_COMPLETE';
var FETCH_DATA_FAILED = exports.FETCH_DATA_FAILED = 'FETCH_DATA_FAILED';
var PAGE_DATA_RECEIVED = exports.PAGE_DATA_RECEIVED = 'PAGE_DATA_RECEIVED';
var PAGE_DATA_NOT_FOUND = exports.PAGE_DATA_NOT_FOUND = 'PAGE_DATA_NOT_FOUND';
var PAGE_DATA_ERROR = exports.PAGE_DATA_ERROR = 'PAGE_DATA_ERROR';